<a
  [mmTestTarget]="'select-suggestion-link'"
  class="suggestion"
  [class.suggestion--active]="isActive"
  fxLayout="row"
  (click)="onTermSelected(suggestion)">
  <ng-container *ngIf="isHistory">
    <div class="icon__container history">
      <mm-icon name="history"
               class="icon--history"
      ></mm-icon>
    </div>
    <span [innerHTML]="(suggestion?.value) | bold:searchQuery" class="suggestion__content"></span>
    <button class="suggestion__close" (click)="onHistoryRemoved($event, suggestion)" [attr.aria-label]="'HEADER.ALL_PAGES.HEADER.SUGGESTIONS.DELETE_HISTORY_SUGGESTION' | translate">
      <mm-icon name="close"></mm-icon>
    </button>
  </ng-container>
  <ng-container *ngIf="!isHistory && hasParentCategory">
    <div class="icon__container">
      <mm-icon
        name="category"
        class="icon--category"
      ></mm-icon>
    </div>
    <div>
      <span [innerHTML]="(suggestion?.value) | bold:searchQuery" class="suggestion__content"></span>
      <span class="suggestion__category">
      {{ 'CORE.ALL_PAGES.HEADER.SUGGESTION.CATEGORY' | translate }} {{ suggestion?.attrs.parent?.name }}
    </span>
    </div>
  </ng-container>
  <ng-container *ngIf="!isHistory && !hasParentCategory">
    <div class="icon__container search">
      <app-svg-search class="icon--search">
      </app-svg-search>
    </div>
    <span [innerHTML]="(suggestion?.value) | bold:searchQuery" class="suggestion__content"></span>
  </ng-container>
</a>
